// AUTO-GENERATED on dev/build startup. Gitignored — regenerated from .env.
export const RUNTIME_ENV = {
  MERCADO_PAGO_PUBLIC_KEY: "",
  API_BASE: "https://teste.api.nosparasempre.com.br",
} as const;
